export default __webpack_public_path__ + "e7b3df14497e05fede3265e972c88293.svg";